import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import Text from 'components/Core/Text';
import WebsiteImage from 'components/WebsiteImage';
import { STIcon } from 'components/Brand/Icons/STIcon';
import usePodcastImages from 'hooks/usePodcastImages';
import dayJs from 'utils/date';
import { truncateText } from 'utils/text';
import podcastIcon from 'images/podcast-black.svg';

import { NextPodcastWrapper } from './styles';

const NextPodcast = ({ post, otherPlatforms }) => {
  if (!post) {
    return null;
  }

  const data = usePodcastImages();
  const podcastHero = data[0]?.node.image?.file.url;

  const url = post.seo.pageUrl;
  const photo = post.coverPhoto?.image.file?.url;
  const title = truncateText(post.podcastTitle, 40);
  const duration = dayJs.duration(post.minutes, 'minute').format('H[h] m[m]');

  return (
    <NextPodcastWrapper>
      <div className="next-podcast--container">
        <div className="next-podcast--header">
          <Text className="next-podcast--header-title" type="p">
            Listen Next
          </Text>
          <img src={podcastIcon} alt="podcast-mark" />
        </div>
        <div className="next-podcast--body">
          <HyperLink href={url}>
            <div className="next-podcast--image-container">
              <WebsiteImage
                className="next-podcast--image"
                image={photo?.image || podcastHero}
                alt="next-podcast--thumb"
              />
            </div>
            <div className="next-podcast--text-container">
              <Text className="next-podcast--title" type="p">
                {title}
              </Text>
              <div className="next-podcast--text-sub-container">
                <Text className="next-podcast--text-duration" type="p">
                  {duration}
                </Text>
                <STIcon type="icon-play-small" />
              </div>
            </div>
          </HyperLink>
        </div>
        {otherPlatforms && otherPlatforms.length > 0 && (
          <div className="next-podcast--footer">
            <Text className="next-podcast--footer-title" type="p">
              Listen on these platforms
            </Text>
            <div className="next-podcast--others">
              {otherPlatforms.map((item, index) => {
                return (
                  <HyperLink
                    className="next-podcast--others-item"
                    href={item.link}
                    title={item.title}
                    key={index}
                  >
                    <WebsiteImage
                      className="next-podcast--others-item-img"
                      image={item.logo}
                      alt={item.title}
                    />
                  </HyperLink>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </NextPodcastWrapper>
  );
};

export default NextPodcast;
